/*------------------------------------*\
    NAV DROPDOWN
\*------------------------------------*/
class NavDropdown {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.trigger = self.elem.querySelector('[data-nav-dropdown-trigger]');
        self.dropdown = self.elem.querySelector('[data-nav-dropdown]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.open = false;
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            evt.preventDefault();

            if (self.open) {
                self.closeDropdown();
            } else {
                self.openDropdown();
            }
        });
    }

    openDropdown() {
        let self = this;

        self.dropdown.classList.add('is-active');
        self.trigger.setAttribute('aria-expanded', true);
        let reflow = self.dropdown.offsetHeight;
        self.dropdown.classList.add('is-visible');
        self.open = true;

        self.addEventListeners();
    }

    closeDropdown() {
        let self = this;

        self.dropdown.classList.remove('is-active');
        self.trigger.setAttribute('aria-expanded', false);
        self.dropdown.classList.remove('is-visible');
        self.open = false;

        self.removeEventListeners();
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown/trigger
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for key presses
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown/trigger
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for key presses
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on:
        // a) this dropdown
        // b) a child element of this dropdown
        if (evt.target !== self.elem && evt.target.closest('[data-module="nav-dropdown"]') !== self.elem) {
            // Close all menus
            self.closeDropdown();
        }
    }

    onEscape(evt) {
        let self = this;

        // If the escape key is pressed
        if (evt.key === "Escape") {
            // Close the dropdown
            self.closeDropdown();
        }
    }
}

export default NavDropdown;
